import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import customDataReducer from "@tSurya/Store/Data/CustomApplicationState/CustomDataReducer";

(reducers as any).SURData = customDataReducer;

// (reducers as any).t_components = componentsReducer;

type CustomReducers = {
    SURData: typeof customDataReducer;
    // t_components: typeof componentsReducer;
};

// creating custom actions along our custom reducers & OOTB actions from AnyAction
export type CustomActions = Parameters<CustomReducers[keyof CustomReducers]>[1] | AnyAction;
